import type {
  SubscriptionPlan,
  CurrentSubscription,
  SubscriptionHistoryItem,
} from './types';

export const mockPlans: SubscriptionPlan[] = [
  {
    id: '019c71a0-1234-7890-abcd-111111111111',
    name: 'Monthly Pro',
    slug: 'monthly-pro',
    duration_days: 30,
    price: '29.99',
    description:
      'Full marketplace access for 30 days. Perfect for trying out the platform.',
    is_active: true,
    sort_order: 1,
    auto_grant_deposit_threshold: null,
  },
  {
    id: '019c71b0-aaaa-7890-abcd-222222222222',
    name: 'Quarterly Standard',
    slug: 'quarterly-standard',
    duration_days: 90,
    price: '49.99',
    description:
      '3-month marketplace access with the best value. Most popular choice.',
    is_active: true,
    sort_order: 2,
    auto_grant_deposit_threshold: '300.00',
  },
  {
    id: '019c71c0-bbbb-7890-abcd-333333333333',
    name: 'Annual Premium',
    slug: 'annual-premium',
    duration_days: 365,
    price: '149.99',
    description:
      'Full year of unlimited marketplace access. Best for power users.',
    is_active: true,
    sort_order: 3,
    auto_grant_deposit_threshold: '500.00',
  },
];

export const mockCurrentSubscription: CurrentSubscription = {
  active: true,
  id: '019c72a0-bbbb-7890-abcd-444444444444',
  plan_name: 'Quarterly Standard',
  plan_slug: 'quarterly-standard',
  starts_at: '2026-02-01T12:30:00+00:00',
  expires_at: '2026-05-02T12:30:00+00:00',
  days_remaining: 72,
  payment_method: 'wallet',
};

export const mockHistory: SubscriptionHistoryItem[] = [
  {
    id: '019c72a0-bbbb-7890-abcd-444444444444',
    user_id: '019c7100-aaaa-7890-abcd-000000000000',
    subscription_plan_id: '019c71b0-aaaa-7890-abcd-222222222222',
    status: 'active',
    starts_at: '2026-02-01T12:30:00.000000Z',
    expires_at: '2026-05-02T12:30:00.000000Z',
    cancelled_at: null,
    payment_method: 'wallet',
    payment_reference: null,
    amount_paid: '49.99',
    currency: 'USD',
    plan: {
      id: '019c71b0-aaaa-7890-abcd-222222222222',
      name: 'Quarterly Standard',
      slug: 'quarterly-standard',
      duration_days: 90,
      price: '49.99',
    },
  },
  {
    id: '019c6900-cccc-7890-abcd-555555555555',
    user_id: '019c7100-aaaa-7890-abcd-000000000000',
    subscription_plan_id: '019c71a0-1234-7890-abcd-111111111111',
    status: 'expired',
    starts_at: '2026-01-01T00:00:00.000000Z',
    expires_at: '2026-01-31T00:00:00.000000Z',
    cancelled_at: null,
    payment_method: 'auto_grant',
    payment_reference: null,
    amount_paid: '0.00',
    currency: 'USD',
    plan: {
      id: '019c71a0-1234-7890-abcd-111111111111',
      name: 'Monthly Pro',
      slug: 'monthly-pro',
      duration_days: 30,
      price: '29.99',
    },
  },
  {
    id: '019c5800-dddd-7890-abcd-666666666666',
    user_id: '019c7100-aaaa-7890-abcd-000000000000',
    subscription_plan_id: '019c71a0-1234-7890-abcd-111111111111',
    status: 'cancelled',
    starts_at: '2025-11-15T00:00:00.000000Z',
    expires_at: '2025-12-15T00:00:00.000000Z',
    cancelled_at: '2025-12-01T10:00:00.000000Z',
    payment_method: 'wallet',
    payment_reference: null,
    amount_paid: '29.99',
    currency: 'USD',
    plan: {
      id: '019c71a0-1234-7890-abcd-111111111111',
      name: 'Monthly Pro',
      slug: 'monthly-pro',
      duration_days: 30,
      price: '29.99',
    },
  },
];
